import { Component } from '@angular/core';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent {

  constructor(
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    if(this.authService.isLoggedIn() == false) {
      location.href = '/login';
    }
  }


}
